import moment from "moment";
import "moment-timezone";
import "eonasdan-bootstrap-datetimepicker"

global.moment = moment;

$.fn.datetimepicker.defaults.icons = {
    time: 'fa fa-clock-o',
    date: 'ps ps-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'glyphicon glyphicon-screenshot',
    clear: 'ps ps-delete',
    close: 'fa fa-times'
}
// global.getComponent = function() {
//     return import(/* webpackChunkName: "fullcalendar" */ "./fullcalendar.js")
//         .then(({ default: _ }) => {
//          console.log(_)
//         })
//         .catch(error => "An error occurred while loading the component");
// }

// getComponent().then(component => {
//     document.body.appendChild(component);
// });
